import React, { Component, forwardRef } from "react";
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { ProfielContext } from "../../../context/profiel-context";

import Any from "../../../hoc/Access/Any";
import {
  Collapse,
  Button,
  List,
  ListItem,
} from "@mui/material";

import Modules from "./Modules";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import LibraryBooks from "@mui/icons-material/LibraryBooks";
import Landscape from "@mui/icons-material/Landscape";
import SettingsIcon from "@mui/icons-material/Settings";
import TrofeeIcon from "@mui/icons-material/EmojiEvents";
import FinansielIcon from "@mui/icons-material/AccountBalance";
import ProduksieIcon from "@mui/icons-material/Movie";
import GrafiekIcon from "@mui/icons-material/Timeline";
import VoertuigIcon from "@mui/icons-material/DirectionsCar";
import KalenderIcon from "@mui/icons-material/Event";
import BesigheidIcon from "@mui/icons-material/Business";
import GewasIcon from "@mui/icons-material/LocalFlorist";
import KultivarIcon from "@mui/icons-material/FilterVintage";
import TeenwoordigheidIcon from "@mui/icons-material/EmojiPeople";
import SyncIcon from "@mui/icons-material/SyncAlt";
import { Icon } from "semantic-ui-react";
import VaardigheidIcon from "@mui/icons-material/Work";
import RolleIcon from "@mui/icons-material/Policy";
import SubscriptionsIcon from "@mui/icons-material/Mail";
import ModulesIcon from "@mui/icons-material/Extension";
import HuurIcon from "@mui/icons-material/LocalAtm";
import { CgColorBucket } from "react-icons/cg";
import KontrakteurJoernale from "@mui/icons-material/MenuBook";
import PlukIcon from "@mui/icons-material/NaturePeople";
import { AdminPanelSettings, CalendarToday, Description, Leaderboard, ManageAccounts, ReceiptLong, Report, Settings, Warning } from "@mui/icons-material";
import { AccessTime, ListAlt } from "@mui/icons-material";
import { Engineering, HomeRepairService, QrCode } from '@mui/icons-material';
import { withTranslation } from "react-i18next";

const PREFIX = 'SidebarNav';

const classes = {
  item: `${PREFIX}-item`,
  nested: `${PREFIX}-nested`,
  button: `${PREFIX}-button`,
  icon: `${PREFIX}-icon`,
  expandIcon: `${PREFIX}-expandIcon`,
  active: `${PREFIX}-active`,
  modulesHeading: `${PREFIX}-modulesHeading`
};

const StyledList = styled(List)((
  {
    theme
  }
) => ({
  [`& .${classes.item}`]: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },

  [`& .${classes.nested}`]: {
    paddingLeft: theme.spacing(4),
    paddingTop: 0,
    paddingBottom: 0,
  },

  [`& .${classes.button}`]: {
    color: theme.palette.primary.main,
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    fontWeight: theme.typography.fontWeightMedium,
    "& :hover": {
      color: theme.palette.primary.main,
    },
    "& :hover $icon ": {
      color: theme.palette.primary.main,
    },
    "& :focus": {
      color: theme.palette.secondary.main,
    },
  },

  [`& .${classes.icon}`]: {
    color: theme.palette.primary.main,
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },

  [`& .${classes.expandIcon}`]: {
    color: theme.palette.primary.main,
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
    cursor: "pointer",
  },

  [`& .${classes.active}`]: {
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
    "& $icon": {
      color: theme.palette.secondary.main,
    },
    "& :hover $icon": {
      color: theme.palette.secondary.main,
    },
    "& :hover": {
      color: theme.palette.secondary.main,
    },
    "& :focus": {
      color: theme.palette.secondary.main,
    },
  },

  [`& .${classes.modulesHeading}`]: {
    marginTop: 5,
    marginBottom: 5,
    textTransform: "uppercase",
    color: theme.palette.primary.light,
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <NavLink {...props} />
  </div>
));

class NestedList extends Component {
  static contextType = ProfielContext;

  state = {};
  handleClick = (e) => {
    this.setState({ [e]: !this.state[e] });
  };

  render() {
    const profielContext = this.context;
    const {  t } = this.props;

    const pages = [
      {
        id: 1,
        title: t("nav.Dashboard"),
        href: "/dashboard",
        icon: <DashboardIcon />,
        permissions: ["dashboard:visit"],
      },
      {
        id: 8,
        title: t("nav.Teenwoordigheid"),
        href: "/teenwoordigheid",
        icon: <TeenwoordigheidIcon />,
        permissions: ["clocking:read"],
      },
      {
        id: 5,
        title: t("nav.Pluk"),
        href: "/pluk",
        icon: <PlukIcon />,
        permissions: ["pluk:rapportering", "plukstate:read"],
        subpages: [
          {
            id: `pluk1`,
            title: t("pluk.Plukstate"),
            href: "/plukstate",
            icon: <LibraryBooks />,
            permissions: ["plukstate:read"],
          },
          {
            id: `pluk2`,
            title: t("pluk.Uitstaande plukstate"),
            href: "/pluk/plukstate/uitstaande",
            icon: <Warning />,
            permissions: ["plukstate:read"],
          },
          {
            id: `pluk5`,
            title: t("pluk.Insidente"),
            href: "/pluk/insidente",
            icon: <Report />,
            permissions: ["insidente:read"],
          },
          {
            id: `pluk3`,
            title: t("pluk.Plukprestasie"),
            href: "/pluk/plukprestasie/plukstate",
            icon: <TrofeeIcon />,
            permissions: ["pluk:rapportering"],
          },
          {
            id: `pluk6`,
            title: t("pluk.Verslae"),
            href: "/pluk/verslae",
            icon: <Description />,
            permissions: ["pluk:rapportering"],
          },
          {
            id: `pluk7`,
            title: t("pluk.Beplanner"),
            href: "/pluk/beplanner",
            icon: <CalendarToday />,
            permissions: ["plukbeplanner_items:read"],
          },
          {
            id: `pluk4`,
            title: t("pluk.Algemene opstellings"),
            href: "/pluk/algemeneopstellings",
            icon: <Settings />,
            permissions: ["plukopstellings:update"],
          },
        ],
      },
      {
        id: 3,
        title: t("nav.Produksie"),
        href: "/produksie",
        icon: <ProduksieIcon />,
        permissions: ["oesskatting:visit"],
        subpages: [
          {
            id: `produksie1`,
            title: t("produksie.Oesskatting"),
            href: "/produksie/oesskatting",
            icon: <GrafiekIcon />,
            permissions: ["oesskatting:visit"],
          },
        ],
      },
      {
        id: 4,
        title: t("nav.Finansieel"),
        href: "/finansieel",
        icon: <FinansielIcon />,
        permissions: ["lone:read", "ivj:read"],
        subpages: [
          {
            id: `finansieel1`,
            title: t("finansieel.Loonbetalings"),
            href: "/finansieel/lone",
            icon: <Icon name="money" />,
            permissions: ["lone:read"],
          },
          {
            id: `finansieel2`,
            title: t("finansieel.Intervertakking joernale"),
            href: "/finansieel/kontrakteur-joernale",
            icon: <KontrakteurJoernale />,
            permissions: ["ivj:read"],
          },
          {
            id: `finansieel3`,
            title: t("finansieel.Kontrakteur joernale"),
            href: "/finansieel/intervertakking-joernale",
            icon: <SyncIcon />,
            permissions: ["ivj:read"],
          },
        ],
      },
      // {
      //   id: 5,
      //   title: "Rapportering",
      //   href: "/rapportering",
      //   icon: <PieChartIcon />,
      //   permissions: ["pluk:rapportering", "clocking:read"],
      //   subpages: [
      //     {
      //       id: `rapportering1`,
      //       title: "Plukprestasie",
      //       href: "/rapportering/plukprestasie/plukstate",
      //       icon: <TrofeeIcon />,
      //       permissions: ["pluk:rapportering"],
      //     },
      //     {
      //       id: `rapportering2`,
      //       title: "Plukbonusse",
      //       href: "/rapportering/plukbonusse",
      //       icon: <BonusseIcon />,
      //       permissions: ["plukbonusse:rapportering"],
      //     },
      //   ],
      // },
      {
        id: 7,
        title: t("nav.Opstellings"),
        href: "/opstellings",
        icon: <SettingsIcon />,
        permissions: [
          "werknemers:visit",
          "spanne:visit",
          "voertuie:visit",
          "seisoene:visit",
          "gewasse:visit",
          "kultivars:visit",
          "maatskappye:visit",
          "boerderye:visit",
        ],
        subpages: [
          {
            id: `opstelling1`,
            title: t("opstellings.Werknemers"),
            href: "/werknemers",
            icon: <PersonIcon />,
            permissions: ["werknemers:visit"],
          },
          {
            id: `opstelling2`,
            title: t("opstellings.Plukspanne"),
            href: "/plukspanne",
            icon: <PeopleIcon />,
            permissions: ["spanne:visit"],
          },
          {
            id: `opstellingsp`,
            title: t("opstellings.Spanne"),
            href: "/spanne",
            icon: <PeopleIcon />,
            permissions: ["spanne:visit"],
          },
          {
            id: `opstellingvaardighede`,
            title: t("opstellings.Vaardighede"),
            href: "/vaardighede",
            icon: <VaardigheidIcon />,
            permissions: [
              "vaardighede:create",
              "vaardighede:update",
              "vaardighede:delete",
            ],
          },
          {
            id: `toerusting`,
            title: t("opstellings.Toerusting"),
            href: "/toerusting",
            icon: <HomeRepairService />,
            permissions: ["toerusting:visit"],
          },
          {
            id: `opstelling3`,
            title: t("opstellings.Vloot"),
            href: "/vloot",
            icon: <VoertuigIcon />,
            permissions: ["voertuie:visit"],
          },
          {
            id: `opstellinghuuritems`,
            title: t("opstellings.Huur items"),
            href: "/huuritems",
            icon: <HuurIcon />,
            permissions: ["huuritems:visit"],
          },
          {
            id: `opstellingverbruiksitems`,
            title: t("opstellings.Verbruiksitems"),
            href: "/verbruiksitems",
            icon: <CgColorBucket />,
            permissions: ["verbruiksitem:visit"],
          },
          {
            id: `opstellingdatabronne`,
            title: t("opstellings.Databronne"),
            href: "/databronne",
            icon: <LibraryBooks />,
            permissions: ["databronne:read"],
          },
          {
            id: `opstellingrolle`,
            title: t("opstellings.Rolle"),
            href: "/rolle",
            icon: <RolleIcon />,
            permissions: ["rolle:visit"],
          },
          {
            id: `opstelling11`,
            title: t("opstellings.Subskripsies"),
            href: "/subskripsies",
            icon: <SubscriptionsIcon />,
            permissions: ["rolle:visit"],
          },
          {
            id: `opstelling12`,
            title: t("opstellings.Dienste"),
            href: "/dienste",
            icon: <ModulesIcon />,
            permissions: ["dienste:visit"],
          },
          // {
          //   id: `opstelling14`,
          //   title: "Modules",
          //   href: "/modules",
          //   icon: <ModulesIcon />,
          //   permissions: ["modules:read"],
          // },
          {
            id: `opstelling10`,
            title: t("opstellings.Teenwoordigheid"),
            href: "/opstellings/teenwoordigheid",
            icon: <AccessTime />,
            permissions: ["tydsbeheeropstelling:read"],
          },
          {
            id: `opstelling9`,
            title: t("opstellings.Betaalmetodes"),
            href: "/betaalmetodes",
            icon: <HuurIcon />,
            permissions: ["betaalmetode:read"],
          },
          {
            id: `opstelling4`,
            title: t("opstellings.Seisoene"),
            href: "/seisoene",
            icon: <KalenderIcon />,
            permissions: ["seisoene:visit"],
          },
          {
            id: `opstelling5`,
            title: t("opstellings.Gewasse"),
            href: "/gewasse",
            icon: <GewasIcon />,
            permissions: ["gewasse:visit"],
          },
          {
            id: `opstelling6`,
            title: t("opstellings.Kultivars"),
            href: "/kultivars",
            icon: <KultivarIcon />,
            permissions: ["kultivars:visit"],
          },
          {
            id: `opstelling7`,
            title: t("opstellings.Maatskappye"),
            href: "/maatskappye",
            icon: <BesigheidIcon />,
            permissions: ["maatskappye:visit"],
          },
          {
            id: `opstelling8`,
            title: t("opstellings.Boerderye"),
            href: "/boerderye",
            icon: <Landscape />,
            permissions: ["boerderye:visit"],
          },
        ],
      },
      {
        id: 9,
        title: t("nav.Operationeel"),
        href: "/operationeel",
        icon: <Engineering />,
        permissions: [
          "qrkodes:create",
        ],
        subpages: [
          {
            id: `operationeel1`,
            title: t("operationeel.QR Kodes"),
            href: "/qrkodes",
            icon: <QrCode />,
            permissions: ["qrkodes:create"],
          },
        ]
      },
      {
        id: 11,
        title: t("nav.Logs"),
        href: "/transaksies",
        icon: <ListAlt />,
        permissions: ["transaksielog:read"],
      },
      {
        id: 12,
        title: t("nav.Rekening"),
        href: "/rekening",
        icon: <AdminPanelSettings />,
        permissions: [
          "rekening:bills",
          "rekening:verbruik",
          "rekening:settings"
        ],
        subpages: [
          {
            id: `rekening3`,
            title: t("rekening.Rekeninge"),
            href: "/rekening/rekeninge",
            icon: <ReceiptLong />,
            permissions: ["rekening:bills"],
          },
          {
            id: `rekening1`,
            title: t("rekening.Verbruiksdata"),
            href: "/rekening/verbruik",
            icon: <Leaderboard />,
            permissions: ["rekening:verbruik"],
          },
          {
            id: `rekening2`,
            title: t("rekening.Verstellings"),
            href: "/rekening/verstellings",
            icon: <SettingsIcon />,
            permissions: ["rekening:settings"],
          },
        ]
      },
    ];

    return (
      <StyledList className={classes.root}>
        {pages.map((page, index) => {
          return (
            <div key={`page-${page.id}`}>
              {page.subpages != null ? (
                <div>
                  <Any
                    permissionsowned={profielContext.profiel.bittoelatings}
                    permissionsneeded={page.permissions}
                    yes={() => (
                      <ListItem className={classes.item} disableGutters>
                        <Button
                          variant="navigation"
                          startIcon={page.icon}
                          to={page.href}
                          disabled={!page.href ? true : false}
                          component={CustomRouterLink}
                        >
                          {page.title}
                        </Button>
                        {this.state[page.title] ? (
                          <ExpandLess
                            onClick={this.handleClick.bind(this, page.title)}
                            className={classes.expandIcon}
                          />
                        ) : (
                          <ExpandMore
                            onClick={this.handleClick.bind(this, page.title)}
                            className={classes.expandIcon}
                          />
                        )}
                      </ListItem>
                    )}
                    no={() => null}
                  />
                  <Collapse
                    component="li"
                    in={this.state[page.title]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List disablePadding>
                      {page.subpages.map((subpage) => {
                        return (
                          <Any
                            key={`subpage-${subpage.id}`}
                            permissionsowned={
                              profielContext.profiel.bittoelatings
                            }
                            permissionsneeded={subpage.permissions}
                            yes={() => (
                              <ListItem className={classes.nested}>
                                <Button
                                  variant="navigation"
                                  startIcon={subpage.icon}
                                  component={CustomRouterLink}
                                  to={subpage.href}
                                  disabled={!subpage.href ? true : false}
                                >
                                  {subpage.title}
                                </Button>
                              </ListItem>
                            )}
                            no={() => null}
                          />
                        );
                      })}
                    </List>
                  </Collapse>{" "}
                </div>
              ) : (
                <Any
                  key={`page-${page.id}`}
                  permissionsowned={profielContext.profiel.bittoelatings}
                  permissionsneeded={page.permissions}
                  yes={() => (
                    <ListItem className={classes.item} disableGutters>
                      <Button
                        variant="navigation"
                        startIcon={page.icon}
                        component={CustomRouterLink}
                        to={page.href}
                      >
                        {page.title}
                      </Button>
                    </ListItem>
                  )}
                  no={() => null}
                />
              )}
            </div>
          );
        })}
        <Modules />
      </StyledList>
    );
  }
}
NestedList.propTypes = {
  classes: PropTypes.object,
};
export default (withTranslation(["translation"])(NestedList));
